import { successToastClassName, appToast as toast, warningToastClassName } from "@/components/ui/baseUi/sonner"
import { Text } from "@/components/ui/baseUi/text"
import { word } from "@modules/core/utils/i18n"
import { useMySpaceNavigate } from "@modules/navigation/hooks/useMySpaceNavigate"
import { Path } from "@modules/navigation/routes"
import { useProgram } from "@modules/programs/hooks/usePrograms"
import { ProgramSubscriptionStatus, ProgramType } from "@modules/programs/types/programTypes"
import { LoadingSpinner } from "@modules/ui/components/loading"
import { useQueryClient } from "@tanstack/react-query"
import { useEffect, useState } from "react"

export function ProgramSubscribingView({ programId }: { programId: string }) {
  const mySpaceNavigate = useMySpaceNavigate()
  const queryClient = useQueryClient()
  const { data: program } = useProgram(programId)
  const [refetchCount, setRefetchCount] = useState(0)

  const programPath =
    program.type === ProgramType.ONOFF
      ? Path.MySpace.ProgramOnOffDetails(programId)
      : Path.MySpace.ProgramDetails(programId)

  useEffect(() => {
    const interval = setInterval(() => {
      queryClient.invalidateQueries({
        queryKey: ["program", programId],
      })
      setRefetchCount((prev) => prev + 1)
    }, 1000)

    return () => clearInterval(interval)
  }, [queryClient, programId])

  useEffect(() => {
    if (program) {
      if (program.subscriptionStatus !== ProgramSubscriptionStatus.INACTIVE) {
        toast.success(word("program.subscribe.success.toast"), {
          classNames: successToastClassName(),
        })
        mySpaceNavigate(programPath)
      } else if (refetchCount >= 20) {
        toast.warning(word("program.subscribe.error.toast"), {
          classNames: warningToastClassName(),
        })

        mySpaceNavigate(programPath)
      }
    }
  }, [program, mySpaceNavigate, programId, refetchCount])

  return (
    <div className="absolute top-0 left-0 z-5 flex h-full w-full flex-col items-center justify-center gap-4">
      <Text fontStyle="BM">
        {program.type === ProgramType.ONOFF ? word("program.purchase.ongoing") : word("program.subscribing.ongoing")}
      </Text>
      <div className="h-8">
        <LoadingSpinner />
      </div>
    </div>
  )
}
